import { SDKConfig, IDENTITY_TYPES } from '@ninjacart/feature-flip-sdk-core';

const PROJECT_DETAILS = {
  REALM_ID: 'dd180bca-465a-470a-abe4-9d5a15ded551',
  USER_ID: '1',
  NAME: 'Trader Ecosystem',
};

export const createFeatureFlipConfig = (
  onError: () => void,
  systemUserId: string,
  realmId?: string
): SDKConfig => ({
  core: {
    baseUrl: `${process.env.NEXT_PUBLIC_FEATURE_TOGGLE_BASE_URL}/v1/realms/${
      realmId || 1
    }/users/${systemUserId}`,
    project: {
      realmId: PROJECT_DETAILS.REALM_ID,
      userId: PROJECT_DETAILS.USER_ID,
      projectId: `${process.env.NEXT_PUBLIC_FEATURE_TOGGLE_PROJECT_ID}`,
      projectName: PROJECT_DETAILS.NAME,
      toolId: `${process.env.NEXT_PUBLIC_X_NC_TOOLID}`,
    },
  },
  identity: {
    type: IDENTITY_TYPES.USER_ID,
    value: systemUserId || '',
  },
  onErrorCallback: () => onError(),
  cache: {
    enabled: true,
    isCacheFallback: true,
    storage: 'localStorage',
  },
});

export { IDENTITY_TYPES };
